// export const AgentAssistRoleNames = {
//   AGENT_ASSIST_ADMIN: 'Agent Manager',
//   AGENT_ASSIST_AGENT: 'Agent',
// };
// export const AnalyticsRoleNames = {
//   ANALYTICS_ADMIN: 'Analytics Admin',
//   ANALYTICS_MEMBER: 'Analytics Member',
//   ANALYTICS_VIEWER: 'Analytics Viewer',
// };
export const ProStudioRoleNames = {
  PRO_STUDIO_ADMIN: 'Pro Studio Admin',
  PRO_STUDIO_VIEWER: 'Pro Studio Viewer',
};

export const hasOnlyTargetProjectRole = ({
  roles = [],
  targetRole,
}: {
  roles?: string[];
  targetRole: string;
}): boolean => {
  if (roles.length === 0) return false;

  const hasTargetRole = roles.some((r) => r === targetRole);
  const hasOtherRoles = roles.some((r) => r !== targetRole);

  return hasTargetRole && !hasOtherRoles;
};

export const isProStudioViewer = (roles?: string[]): boolean => {
  return hasOnlyTargetProjectRole({
    roles,
    targetRole: ProStudioRoleNames.PRO_STUDIO_VIEWER,
  });
};
